import React, { useState, useEffect } from "react";
import "../../App.css"; // Import global styles
import { FaAngleUp, FaAngleDown, FaMapMarkerAlt, FaEnvelope, FaPhone, FaTimes } from "react-icons/fa"; // Import icons
import WebsiteLogo from "../../images/WebsiteLogo.png"; // Import the logo
// import UrCommunityLogo from "../../images/UrCommunityLogo.png"; // Import the logo
import SecurityPolicyPDF from "../components/PDFs/UrVote_Security_Policy.pdf"; // Updated import
import PricinginAustraliaPDF from "../components/PDFs/UrVote_Pricing_in_Australia.pdf"; // Updated import
import PrivacyPolicyPDF from "../components/PDFs/UrVote_Privacy_Policy.pdf"; // Updated import
import TermsConditionsPDF from "../components/PDFs/UrVote_Terms_and_Conditions.pdf"; // Updated import
import CommunityDiscussionPDF from "../components/PDFs/UrVote_Community_Discussion_Rules.pdf"; 
import LocalProjectCompetitionPDF from "../components/PDFs/UrVote_Local_Projects_Competition.pdf";
import ContactUs from "../components/ContactUs"; // Import the ContactUs component
import CandidateDisclaimerPDF from "../components/PDFs/Candidate_Disclaimer.pdf"; // Add new import
import { useNavigate } from 'react-router-dom'; // Add this import

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
  const navigate = useNavigate(); // Add navigation hook

  // Custom scrollbar styles - only for mobile portrait mode
  const styles = `
    @media screen and (max-width: 926px) and (orientation: portrait) {
      .footer-content::-webkit-scrollbar {
        width: 6px;
      }

      .footer-content::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }

      .footer-content::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 3px;
      }

      .footer-content::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  `;

  // Add effect to handle orientation changes
  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Add styles to document
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const toggleFooter = () => {
    setIsOpen(!isOpen);
  };

  const toggleContactPopup = () => {
    setIsContactPopupOpen(!isContactPopupOpen);
  };

  return (
    <div className={`footer-container ${isOpen ? "open" : ""}`}>
      {/* Footer content */}
      {isOpen && (
        <div className="footer-content" style={{
          maxHeight: window.innerWidth <= 926 && isPortrait ? "70vh" : "none",
          overflowY: window.innerWidth <= 926 && isPortrait ? "auto" : "hidden", // Hide overflow on laptop
          overflowX: "hidden",
          padding: window.innerWidth > 926 ? "20px 0 0 0" : "0"
        }}>
          <div className="footer-columns" style={{
            flexDirection: window.innerWidth <= 926 && isPortrait ? "column" : "row",
            gap: window.innerWidth <= 926 && isPortrait ? "20px" : "initial",
            padding: window.innerWidth > 926 ? "0 20px" : "10px",
            overflow: window.innerWidth > 926 ? "hidden" : "visible" // Hide overflow on laptop
          }}>
            {/* Column 1 */}
            <div className="footer-column" style={{ 
              textAlign: "center",
              width: window.innerWidth <= 926 && isPortrait ? "100%" : "auto",
              padding: window.innerWidth > 926 ? "0 15px" : "0"
            }}>
              <img
                src={WebsiteLogo}
                alt="UrCommunity Logo"
                className="footer-logo"
                style={{
                  width: "180px",  // Reduced from default size
                  height: "auto",  // Maintain aspect ratio
                  maxWidth: "100%"  // Ensure responsiveness
                }}
              />
              <div className="footer-copyright" style={{
                marginTop: "20px",
                textAlign: "center"
              }}>
                <p>© Copyright UrCommunity Ltd</p>
              </div>
            </div>

            {/* Column 2 - Location */}
            <div className="footer-column" style={{
              width: window.innerWidth <= 926 && isPortrait ? "100%" : "auto",
              padding: window.innerWidth > 926 ? "0 15px" : "0"
            }}>
              <h3 className="footer-column-title">Location</h3>
              <div className="footer-info">
                <p>
                  <FaMapMarkerAlt className="footer-icon" /> PO Box 1113, Werribee Plaza, VIC, 3029
                </p>
                <p>
                  <FaEnvelope className="footer-icon" /> urvote@urcommunity.org.au
                </p>
                <p>
                  <FaPhone className="footer-icon" style={{ transform: "rotate(90deg)" }} /> 1300 653 185
                </p>
              </div>
              
              {/* Terms & Conditions Note */}
              <p style={{
                color: 'white',
                fontSize: '14px',
                fontStyle: 'italic',
                marginTop: '20px',
                textAlign: 'left'
              }}>
                * Travel not included & nightly booking fees & {' '}
                <a 
                  href="https://globalvacationreward.com/terms/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: 'white',
                    textDecoration: 'underline'
                  }}
                >
                  Terms & Conditions
                </a>
                {' '}apply.
              </p>

              {/* Draw Statement */}
              <p style={{
                color: '#fff',
                fontSize: '14px',
                marginTop: '10px',
                textAlign: 'left'
              }}>
                The Draw for the Vacation Voucher Prizes will be held at the UrVote office on Tuesday 6 May at 12 noon.
              </p>
            </div>

            {/* Column 3 - Information */}
            <div className="footer-column" style={{
              width: window.innerWidth <= 926 && isPortrait ? "100%" : "auto",
              padding: window.innerWidth > 926 ? "0 15px" : "0"
            }}>
              <h3 className="footer-column-title">Information</h3>
              {/* Wrapper for two sub-columns */}
              <div
                className="footer-subcolumns"
                style={{
                  display: "flex", // Use flexbox for horizontal alignment
                  gap: "20px", // Add space between the two columns
                  justifyContent: "space-between", // Adjust spacing between columns
                }}
              >
                {/* Sub-column 1 */}
                <ul className="footer-links" style={{ flex: 1, listStyle: "none", padding: 0 }}>
                  <li>
                    <a
                      href={SecurityPolicyPDF}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Security Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href={PrivacyPolicyPDF}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      href={TermsConditionsPDF}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Terms & Conditions
                    </a>
                  </li>
                  <li>
                    <a
                      href={PricinginAustraliaPDF}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Pricing
                    </a>
                  </li>
                  <li>
                    <button
                      onClick={() => navigate('/testimonials')}
                      style={{
                        background: "none",
                        border: "none",
                        color: "inherit",
                        cursor: "pointer",
                        padding: 0,
                        textAlign: "left",
                      }}
                    >
                      Testimonials
                    </button>
                  </li>
                </ul>

                {/* Sub-column 2 */}
                <ul className="footer-links" style={{ flex: 1, listStyle: "none", padding: 0 }}>
                  <li>
                    <a
                      href={CommunityDiscussionPDF}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Community Discussion Rules
                    </a>
                  </li>
                  <li>
                    <a
                      href={LocalProjectCompetitionPDF}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Local Project Competition Rules
                    </a>
                  </li>
                  <li>
                    <a
                      href={CandidateDisclaimerPDF}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Candidate Disclaimer
                    </a>
                  </li>
                  <li>
                    <button
                      onClick={toggleContactPopup}
                      style={{
                        background: "none",
                        border: "none",
                        color: "inherit",
                        cursor: "pointer",
                        padding: 0,
                        textAlign: "left",
                      }}
                    >
                      Contact Us
                    </button>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      )}

      {/* Toggle button */}
      <button className="toggle-btn" onClick={toggleFooter}>
        {isOpen ? <FaAngleDown /> : <FaAngleUp />}
      </button>

      {/* Contact Us Popup */}
      {isContactPopupOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            borderRadius: "8px",
            width: "500px",
            maxHeight: "90vh", // Ensures it doesn't exceed the viewport height
            overflowY: "auto", // Makes the content scrollable
            padding: "20px",
            zIndex: 1100, // Ensure popup is in front of all elements
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <h3 style={{ margin: 0 }}>Drop a Message</h3>
            <FaTimes
              onClick={toggleContactPopup}
              style={{
                cursor: "pointer",
                color: "#000",
                fontSize: "18px",
              }}
            />
          </div>
          {/* ContactUs Component */}
          <ContactUs />
        </div>
      )}

      {/* Overlay for popup */}
      {isContactPopupOpen && (
        <div
          onClick={toggleContactPopup}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000, // Ensure overlay is just below the popup
          }}
        ></div>
      )}
    </div>
  );
};

export default Footer;
